import styled from "styled-components";
import { SwipeableDrawer as Swipeable } from "@mui/material";
import color from "../../../../constants/color";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Badge = styled.div`
  position: absolute;
  right: -8px;
  top: -8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #f43636;
  border-radius: 50%;
  height: 16px;
  min-width: 16px;

  p {
    color: white; /* exemplo de estilo */
    font-size: 10px;
    margin: 0;
    text-align: center;
    line-height: 16px;
    font-weight: 500;
  }
`;

export const FilterButton = styled.button`
  display: inline-flex;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 36px;
  border-radius: 4px;
  background: var(--Azul-Primary-100, #d5deff);
  /* Shadow/xs */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: var(--Azul-Primary-500, #2d5bff);
  /* XS/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
  letter-spacing: -0.12px;
  cursor: pointer;
`;

export const FilterButtonOutline = styled.button`
  position: relative;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
`;

export const SwipeableDrawer = styled(Swipeable)`
  .MuiDrawer-paperAnchorRight {
    width: 392px;
    border-radius: 8px 0px 0px 8px;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${color.Mediumgrey};
    }
  }
`;

export const Button = styled.button`
  display: flex;
  width: 142px;
  padding: 6.2px;
  justify-content: center;
  align-items: center;
  gap: 6.2px;
  border-radius: 6.2px;
  background: var(--Azul-Primary-200, #abbdff);
  box-shadow: 0px 0.947px 1.894px 0px rgba(16, 24, 40, 0.05);
  color: #2d5bff;
  cursor: pointer;
`;
